// eslint-disable-next-line no-restricted-imports
import type { FormControlProps, RadioGroupProps, RadioProps } from '@mui/material';
// eslint-disable-next-line no-restricted-imports
import {
  FormControl as MuiFormControl,
  Radio as MuiRadio,
  RadioGroup as MuiRadioGroup
} from '@mui/material';

export type { FormControlProps, RadioGroupProps, RadioProps };

export const Radio = ({ size = 'small', ...props }: RadioProps) => (
  <MuiRadio
    size={size}
    {...props}
  />
);

export const RadioGroup = (props: RadioGroupProps) => <MuiRadioGroup {...props} />;

export const FormControl = (props: FormControlProps) => <MuiFormControl {...props} />;
